import { useEffect, useState } from "react";

export default function ShareBar({ title }: { title: string }) {
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState("");

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(() => setToast(""), 2200);
    return () => window.clearTimeout(timer);
  }, [toast]);

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setToast("链接已复制，可直接粘贴分享");
    } catch {
      setToast("当前浏览器不支持自动复制，请手动复制地址栏链接");
    }
  };

  const shareTo = (platform: string) => {
    setOpen(false);
    setToast(`${platform}分享为演示功能，已复制标题与链接，请手动粘贴`);
    navigator.clipboard?.writeText(`${title} ${window.location.href}`).catch(() => undefined);
  };

  return (
    <div className="relative">
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={copyLink}
          className="inline-flex items-center gap-1.5 h-9 px-3.5 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-link" />
          复制链接
        </button>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="inline-flex items-center gap-1.5 h-9 px-3.5 rounded-md bg-secondary-500 text-background-50 text-sm hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-share-forward-line" />
          分享到社交平台
        </button>
      </div>

      {open && (
        <div className="absolute right-0 top-full mt-2 z-20 w-[236px] rounded-lg border border-background-200 bg-background-50 p-2 animate-fade-in">
          <p className="px-2 py-1.5 text-[11px] tracking-widest text-foreground-400 font-label">
            SHARE · 演示
          </p>
          {[
            { name: "微博", icon: "ri-weibo-line" },
            { name: "微信", icon: "ri-wechat-line" },
            { name: "QQ", icon: "ri-qq-line" },
          ].map((platform) => (
            <button
              key={platform.name}
              type="button"
              onClick={() => shareTo(platform.name)}
              className="w-full flex items-center gap-2 px-2 h-9 rounded-md text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className={`${platform.icon} text-base`} />
              分享到{platform.name}
            </button>
          ))}
        </div>
      )}

      {toast && (
        <div className="fixed left-1/2 -translate-x-1/2 bottom-8 z-50 max-w-[90vw] rounded-md bg-foreground-900 px-4 py-2.5 text-sm text-background-50 animate-fade-up">
          {toast}
        </div>
      )}
    </div>
  );
}